module.exports = __webpack_public_path__ + "static/img/ninja-can-26.8adca591.png";